export default __webpack_public_path__ + "static/media/2.b3919bd2.jpg";